import React, { useState, useCallback } from 'react';

type Props = {
  recibo: string;
};

const ReciboPagamentoMedico: React.FC<Props> = ({ recibo }) => {
  // const location = useLocation();
  // const { recibo } = location.state as Props;
  const handleHTML = useCallback((texto: string) => {
    return texto
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }, []);

  const [reciboFormatado, setRecibo] = useState<string>(handleHTML(recibo));

  // useEffect(() => {
  //   async function loadDados(): Promise<void> {
  //     setLoading(true);
  //     try {
  //       const response = await api.get(`/tratamento/contrato/${id}`);

  //       setContrato(handleHTML(response.data.ConContrato));
  //     } catch (error) {
  //       const mensagem = getResponseErrors(error);
  //       addToast({
  //         type: 'error',
  //         title: 'Não foi possível carregar dados do contrato',
  //         description: mensagem,
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  //   loadDados();
  // }, [id, addToast, handleHTML]);

  return (
    <div className="p-0 m-0 bg-white">
      {reciboFormatado && (
        <span dangerouslySetInnerHTML={{ __html: reciboFormatado }} />
      )}
    </div>
  );
};

export default ReciboPagamentoMedico;
